module.exports = __webpack_public_path__ + "static/profile-d7448b6014fb6df9ff127d9fed7bb4b7.jpg";